import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { BrandMark } from "../components/Brand";

const STROKE = 1.5;

export default function Forbidden() {
  return (
    <div className="min-h-screen bg-ink-50" data-testid="403-page">
      <header className="border-b border-ink-200 bg-white">
        <div className="hp-container flex h-16 items-center justify-between">
          <Link to="/dashboard"><BrandMark /></Link>
        </div>
      </header>
      <main className="flex flex-col items-center justify-center px-6 py-24 text-center">
        <ShieldOff className="h-7 w-7 text-emerald-800" strokeWidth={STROKE} />
        <h1 className="font-display mt-6 text-4xl font-medium tracking-tight text-ink-900">
          Access restricted
        </h1>
        <p className="mt-3 max-w-md text-[14px] text-ink-500">
          You don&rsquo;t have permission to view this page in this workspace. If you think this
          is a mistake, ask your workspace admin to adjust your role.
        </p>
        <Link to="/dashboard" className="hp-btn-primary mt-8" data-testid="forbidden-back">
          Back to dashboard
        </Link>
      </main>
    </div>
  );
}
